<template>
  <ModalBase show-modal @close-modal="close" auto-h class="gk-modal-accept-quotation">
    <template v-slot:titlebar>
      <TitleBar variant-class="title-modal title-modal--simple">
        <template v-slot:title>
          {{ title }}
        </template>
      </TitleBar>
    </template>

    <template v-slot:maincontent>
      <div v-if="options && options.item" class="target-item">
        {{ options.item }}
      </div>
      <div v-html="message" />

      <div class="py-3">
        <b-form-input v-model="clientName" :placeholder="$gettext('Your name')" />
      </div>

      <div v-if="options && options.safeguard">
        <b-form-checkbox
          id="checkbox-safeguard"
          v-model="safeguarded"
          name="checkbox-safeguard"
        >
          {{ options.safeguardText }}
        </b-form-checkbox>
      </div>
    </template>

    <template v-slot:actions>
      <GekkoButton
        @click="close()"
        :text="$gettext('Cancel')"
        variant="light"
      />
      <GekkoButton
        @click="confirmAction()"
        :disabled="((options && options.safeguard && !safeguarded) || (!validClientName))"
        :text="confirmText"
        :variant="variant"
      />
    </template>
  </ModalBase>
</template>

<script>
import ModalBase from "@/components/base_components/ModalBase";
import TitleBar from "@/components/TitleBar";
import GekkoButton from "@/components/GekkoButton";

export default {
  name: 'QuotationChangeStatusModal',
  components: { ModalBase, TitleBar, GekkoButton },
  props: {
    interactMode: {
      type: String,
      default: 'title default value'
    },
  },
  data () {
    return {
      selectedChoice: null,
      confirmationWarning: false,
      safeguarded: false,
      title: '',
      message: '',
      options: {},
      confirmActionEvent: '',
      clientName: ''
    }
  },
  computed: {
    confirmText () {
      return (this.options && this.options.confirmText) ? this.options.confirmText : this.$gettext('Confirm') 
    },
    variant () {
      return (this.options && this.options.variant) ? this.options.variant : 'primary'
    },
    validClientName () {
      return /\S/.test(this.clientName)
    }
  },
  created () {
    this.setupData();
  },
  methods: {
    close () {
      this.$emit('close')
    },
    setupData () {
      if (this.interactMode === 'accept') {
        this.title = this.$gettext('Accept quotation'),
        this.message = this.$gettext('In order to accept this quotation, please provide your name'),
        this.options = {
          variant: 'primary',
          confirmText: this.$gettext('Accept quotation'),
          safeguard: true,
          safeguardText: this.$gettext('I accept this quotation with all the attached documents')
        }
        this.confirmActionEvent = 'accept-quotation'
      }
      if (this.interactMode === 'reject') {
        this.title = this.$gettext('Reject quotation'),
        this.message = this.$gettext('In order to reject this quotation, please provide your name'),
        this.options = {
          variant: 'danger',
          confirmText: this.$gettext('Reject quotation')
        }
        this.confirmActionEvent = 'reject-quotation'
      }
    },
    confirmAction () {
      this.$emit(this.confirmActionEvent, this.clientName)
    }
  }
}
</script>

<style lang="scss">
.gk-modal-accept-quotation {
  position: absolute;
  z-index: 9001;
  .gk-modal {
    max-width: 530px !important;
    padding: 1rem;
    @media (min-width: 768px) {
      padding: 1.5rem;
    }
    .titlebar.title-modal { margin-bottom: 0; }
    .modal-content-wrap {
      padding: 0.5rem 0;
      font-size: 1rem;

      .target-item {
        padding: 1rem;
        margin-bottom: 1rem;
        border-radius: $radiusLg;
        background: $colorBorderDash;
      }
    }
    .action-buttons-wrapper {
      display: flex;
      gap: 0.75rem;
      justify-content: flex-end;
    }
  }
}
</style>